<template>
  <span>
    <input
      :accept="accept"
      ref="input"
      type="file"
      style="display: none"
      @change="onFileSelected"
    />
    <bcc-button
      size="small"
      style="padding: 8px 12px!important"
      @click="uploadQuestionnaire($event)"
    >
    {{ btnTxt }}
    </bcc-button>
  </span>
</template>
<script>
export default {
  props: {
    accept: {
      type: String,
      default: '*'
    },
    btnTxt: {
      type: String,
      default: '上传附件'
    },
    uploader: {
      type: Function,
      default: (file) => {
        console.log(file)
      }
    },
  },
  data () {
    let state = 0
    if (this.source) state = 2
    return {
      state // 0 select 1 uploading 2 review
    }
  },
  methods: {
    async uploadQuestionnaire(e) {
      e.preventDefault();
      this.$refs['input'].click()
    },
    onFileSelected(e) {
      const file = e.target.files[0]
      this.uploadFile(file)
    },
    uploadFile(file) {
      if (!file) return
      const filename = file.name
      const ext = filename.split('.').pop()
      const accept = this.accept.split(',')
      if (!accept.includes(`.${ext}`)) {
        this.$message({
          content: `文件格式不支持，仅支持 ${accept.join(' ')}`,
          type: 'exception',
          offset: 60,
          duration: 1500
        })
        return
      }
      this.state = 1
      this.uploader(file).then(url => {
        if (url) {
          this.state = 2
          this.$emit('complete', url)
        } else {
          if (this.source) {
            this.state = 2
          } else {
            this.state = 0
          }
        }
      }).catch(e => {
        console.error(e)
      })
    },
  }
}
</script>